import { ReactNode } from "react";

/**
 * Whether there is anything worth putting in a tooltip. `ReactNode` allows several values that render nothing —
 * `undefined`, `null`, booleans (e.g. from `someFlag && "text"`) and blank strings — and wrapping a card for any of
 * them would open an empty tooltip bubble on hover.
 * @param content - Candidate tooltip content.
 * @returns Whether the content renders something.
 */
export const checkHasTooltipContent = (content: ReactNode): boolean => {
    if (typeof content === "undefined" || content === null || typeof content === "boolean") {
        return false;
    }

    return typeof content === "string" ? content.trim().length > 0 : true;
};
